import useI18nHelper from "@/features/ui/hooks/use-i18n-helper";
import usePathPickProductCardView from "@/features/pathpick/hooks/usePathPickProductCardView";
import { PathPickProductOrderBy } from "@/features/pathpick/types";

export interface PathPickProductSortOption {
  name: string;
  value: PathPickProductOrderBy;
}

// 상품 찾기 정렬 옵션 — 헤더의 정렬 셀렉트와 모바일 필터 모달이 같은 목록을 쓴다.
// 마진순·거래순 4종은 카드의 비교 정보를 보고 고르는 정렬이라 비교 표시를 끄면 함께 내린다.
const usePathPickProductSortOptions = (): PathPickProductSortOption[] => {
  const { t } = useI18nHelper();
  const { isComparisonVisible } = usePathPickProductCardView();

  return [
    {
      name: t("path_pick:search_products.product_list.sort_recommended"),
      value: "recommended",
    },
    // {
    //   name: t("path_pick:search_products.product_list.sort_popular"),
    //   value: "popular",
    // },
    {
      name: t("path_pick:search_products.product_list.sort_latest"),
      value: "latest",
    },
    ...(isComparisonVisible
      ? ([
          {
            name: t("path_pick:search_products.product_list.sort_kream_margin"),
            value: "kream_margin_desc",
          },
          {
            name: t(
              "path_pick:search_products.product_list.sort_poizon_margin"
            ),
            value: "poizon_margin_desc",
          },
          {
            name: t("path_pick:search_products.product_list.sort_kream_sales"),
            value: "kream_sales_desc",
          },
          {
            name: t("path_pick:search_products.product_list.sort_poizon_sales"),
            value: "poizon_sales_desc",
          },
        ] as PathPickProductSortOption[])
      : []),
  ];
};

export default usePathPickProductSortOptions;
